import { useParams } from "react-router-dom";
import type { PurchaseParamsT } from "../models/models";
import { useUser } from "../../../../contexts/userContext/userContext";
import { BillingDetailsT } from "../../../../models/models";

const useCurrentTokenId = () => {
  const { packageType } = useParams<PurchaseParamsT>();
  const { getUserBillingDetails } = useUser();

  const billingDetails = getUserBillingDetails() as BillingDetailsT;

  const addonsTokenId = billingDetails?.addons?.[0]?.token_id;
  const subscriptionTokenId = billingDetails?.token_id;

  const isAddonBillingCycle =
    packageType === "sub-users" || packageType === "extra-storage";
  const isSubscriptionBillingCycle =
    packageType === "business" ||
    packageType === "premium" ||
    packageType === "pro";

  return isAddonBillingCycle
    ? addonsTokenId
    : isSubscriptionBillingCycle
    ? subscriptionTokenId
    : null;
};

export default useCurrentTokenId;